import createSelector from 'lib/createSelector'
import { sum } from 'lib/arrayUtils'
import { isLuxuryPlusSubscriptionItem } from 'lib/checkout'
import { addYears, intlFormatter } from 'lib/dateUtils'
import { INTL_DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'

export const getLuxuryPlusSubscriptionItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.LuxuryPlusSubscriptionItem> => items.filter(isLuxuryPlusSubscriptionItem),
)

export const isStandaloneLuxuryPlusSubscription = createSelector(
  (state: App.State) => state.checkout.cart.items,
  getLuxuryPlusSubscriptionItems,
  (items, luxuryPlusItems): boolean => !!items.length && items.length === luxuryPlusItems.length,
)

export const getLuxuryPlusSubscriptionItemView = createSelector(
  (state: App.State) => getLuxuryPlusSubscriptionItems(state),
  (luxuryPlusItems): App.WithDataStatus<Array<App.Checkout.LuxuryPlusSubscriptionItemView>> => {
    return {
      hasRequiredData: true,
      data: luxuryPlusItems.map(item => {
        return {
          itemId: item.itemId,
          price: item.amount,
          taxesAndFees: 0,
        }
      }),
    }
  },
)

export const getLuxuryPlusBreakdownView = createSelector(
  getLuxuryPlusSubscriptionItemView,
  (viewWithStatus): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    if (viewWithStatus.data.length === 0) { return { hasRequiredData: viewWithStatus.hasRequiredData, data: [] } }
    const breakdownView = {
      title: 'LuxuryPlus+ Membership',
      price: sum(viewWithStatus.data, item => item.price || 0),
      additionalInfoText: [
        'One year membership',
        `Auto renews on ${intlFormatter(addYears(new Date(), 1), INTL_DMY_CASUAL_SHORT_FORMAT)}`,
      ],
      items: [],
    }

    return {
      hasRequiredData: true,
      data: [breakdownView],
    }
  },
)
